module.exports = __webpack_public_path__ + "img/f51.758bc30b.png";